var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributeTextEditor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25600_346641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.3125C1.94062 16.3125 1.6875 16.0594 1.6875 15.75V2.25C1.6875 1.94062 1.94062 1.6875 2.25 1.6875H7.875V4.5C7.875 5.12227 8.37773 5.625 9 5.625H11.8125V15.75C11.8125 16.0594 11.5594 16.3125 11.25 16.3125H2.25ZM2.25 0C1.00898 0 0 1.00898 0 2.25V15.75C0 16.991 1.00898 18 2.25 18H11.25C12.491 18 13.5 16.991 13.5 15.75V5.43164C13.5 4.83398 13.2645 4.26094 12.8426 3.83906L9.65742 0.657422C9.23555 0.235547 8.66602 0 8.06836 0H2.25ZM4.21875 9C3.75117 9 3.375 9.37617 3.375 9.84375C3.375 10.3113 3.75117 10.6875 4.21875 10.6875H9.28125C9.74883 10.6875 10.125 10.3113 10.125 9.84375C10.125 9.37617 9.74883 9 9.28125 9H4.21875ZM4.21875 12.375C3.75117 12.375 3.375 12.7512 3.375 13.2188C3.375 13.6863 3.75117 14.0625 4.21875 14.0625H9.28125C9.74883 14.0625 10.125 13.6863 10.125 13.2188C10.125 12.7512 9.74883 12.375 9.28125 12.375H4.21875Z",
    fill: "#626F86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25600_346641"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H13.5V18H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributeTextEditor);
export default __webpack_public_path__ + "static/media/attributeTextEditor.e38ac8d486b291b40eb24b82082901fe.svg";
export { ForwardRef as ReactComponent };